/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { ForcBaseArgs } from "parog-web/components/forc/abstract/base-component";
import type Patient from "parog-web/models/patient";
import type { EmberChangeset } from "ember-changeset";
import Questions from "./questions";

interface Signature {
  Args: {
    patient: Patient;
    currentSections: Array<string>;
    save: () => void;
    changeset: EmberChangeset;
  } & ForcBaseArgs;
}
export default class CtcaeCustomBaseEditionForm extends Component<Signature> {
  Questions = Questions;
}
